import React, { createContext, useState, useContext, useCallback } from 'react';

const AuthContext = createContext(null);

const TOKEN_KEY = 'artemis_token';
const USER_KEY  = 'artemis_user';

export const useAuth = () => useContext(AuthContext);

/** Mapeo de user_type a ruta base */
export const USER_TYPE_ROUTES = {
  teacher: '/docente',
  utp:     '/utp',
  admin:   '/admin',
  master:  '/master',
};

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(() => localStorage.getItem(TOKEN_KEY));
  const [user, setUser] = useState(() => {
    const stored = localStorage.getItem(USER_KEY);
    return stored ? JSON.parse(stored) : null;
  });

  const login = useCallback((tokenValue, userData) => {
    // Asegurar que tenant_id esté presente en el objeto user
    const enrichedUser = {
      ...userData,
      tenant_id: userData.tenant_id ?? userData.organization_id ?? 0,
    };
    localStorage.setItem(TOKEN_KEY, tokenValue);
    localStorage.setItem(USER_KEY, JSON.stringify(enrichedUser));
    setToken(tokenValue);
    setUser(enrichedUser);
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
    setToken(null);
    setUser(null);
  }, []);

  const isAuthenticated = Boolean(token && user);

  /** Ruta a la que debe ir este usuario según su tipo */
  const homeRoute = user ? (USER_TYPE_ROUTES[user.user_type] ?? '/') : '/login';

  return (
    <AuthContext.Provider value={{ token, user, isAuthenticated, homeRoute, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
